import React, { useEffect, useState } from "react";
import ContractorConfigurationList from "../component/users/contractor/contractorConfigurationList";
import * as contractorAction from "../../../redux/actions/contractorAction";
import * as userAction from "../../../redux/actions/userAction";
import { API_STATUS, ORG_ID, PAGE_SIZE } from "../../../constant/constant";
import { useDispatch, useSelector } from "react-redux";
import Loader from "../../../library/common/Loader";
import { ToastContainer, toast } from "react-toastify";
import { selectOnboardContractorStatus } from "../../../redux/selectors/adminSelector";
import { PRODUCT_ID } from "../../../constant/storm-water/constant";
import * as adminAction from "../../../redux/actions/adminCommonAction";
import { useNavigate } from "react-router-dom";
import {
  ADMIN_CONTRACTOR_CONFIGURATION_LIST,
  ADMIN_CONTRACTOR_CONFIGURATION_VIEW,
} from "../../../constant/routeContant";
import { getPreviousRoute } from "../../../utils/routeTracker";
import { InactiveClient } from "../../../utils/helper";

function ConrtactorConfigurationListContainer() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [isSuccess, setIsSuccess] = useState(false);
  const [sendEmail, setSendEmail] = useState(false);
  const [shouldRestoreState, setShouldRestoreState] = useState(false);
  const onboardContractorStatus = useSelector(selectOnboardContractorStatus);

  const updateOnboardedContractorListData = useSelector(
    (state) => state.updateOnboardedContractorListData,
  );
  const updateOnboardedContractorListDataStatus = useSelector(
    (state) => state.updateOnboardedContractorListData.status,
  );
  const isLoading = updateOnboardedContractorListData.isLoading;

  const OnboardedContractorListData = useSelector(
    (state) => state.getOnboardedContractorListData,
  );
  const recreateUsersReducer = useSelector((state) => state.recreateUsersData);
  const recreateUsersReducerstatus = useSelector(
    (state) => state.recreateUsersData.status,
  );
  const showLoader = recreateUsersReducer.isLoading;
  const sendBulkEmailVerificationData = useSelector(
    (state) => state.sendBulkEmailVerification,
  );
  const sendBulkEmailVerificationDataIsLoading = useSelector(
    (state) => state.sendBulkEmailVerification?.isLoading,
  );
  const division = useSelector(
    (state) => state.getDropdownDataKeyValue?.data?.divisons,
  );

  const getOnboardedContractorLists = (data) => {
    if (data?.isSendMail) {
      setSendEmail(true);
    } else {
      setSendEmail(false);
    }
    dispatch(contractorAction.getOnboardedContractorList(data));
    dispatch(contractorAction.getContractorConfigurationFilterObj(data));
  };
  const defaultData = {
    page: 1,
    search: "",
    pageSize: PAGE_SIZE,
    Status: "",
    isSendMail: false,
  };

  const dropdownDataKeyValueParams = {
    orgId: ORG_ID(),
    flags: "21,6",
    productId: PRODUCT_ID(),
  };

  useEffect(() => {
    const previousRoute = getPreviousRoute();
    const preserveRoutes = [
      ADMIN_CONTRACTOR_CONFIGURATION_LIST,
      ADMIN_CONTRACTOR_CONFIGURATION_VIEW,
    ];
    const isFromPreserveRoute =
      previousRoute &&
      preserveRoutes.some((r) => previousRoute.startsWith(r)) &&
      sessionStorage.getItem("contractorConfigurationListPreserveState") ===
        "true";
    sessionStorage.removeItem("contractorConfigurationListPreserveState");

    setIsSuccess(false);
    dispatch(adminAction.getDropdownDataKeyValue(dropdownDataKeyValueParams));
    if (isFromPreserveRoute && OnboardedContractorListData?.filterObjs) {
      setShouldRestoreState(true);
      getOnboardedContractorLists(OnboardedContractorListData.filterObjs);
    } else {
      setShouldRestoreState(false);
      getOnboardedContractorLists(defaultData);
    }
    dispatch(userAction.ClearSendEmailVerification());
  }, []);

  useEffect(() => {
    if (
      updateOnboardedContractorListDataStatus === API_STATUS.SUCCESS &&
      updateOnboardedContractorListData?.isLoading === false
    ) {
      setIsSuccess(false);
      setTimeout(() => {
        window.location.reload();
      }, 3800);
    }
  }, [updateOnboardedContractorListDataStatus]);

  useEffect(() => {
    if (
      recreateUsersReducerstatus === API_STATUS.SUCCESS &&
      recreateUsersReducer?.isLoading === false
    ) {
      setIsSuccess(false);
      setTimeout(() => {
        window.location.reload();
      }, 3800);
    }
  }, [recreateUsersReducerstatus]);

  const updateOnboardedContractorList = (data) => {
    setIsSuccess(true);
    if (data.contractorIds.length == 0) {
      toast.error("Please Select Contractor");
      return false;
    }
    dispatch(contractorAction.updateOnboardedContractorList(data));
  };

  const recreateUsersList = (data) => {
    setIsSuccess(true);
    dispatch(userAction.recreateUsers(data));
  };

  useEffect(() => {
    if (
      OnboardedContractorListData?.status === API_STATUS.SUCCESS &&
      sendEmail
    ) {
      toast("Onboarded contractors has been sent to registered email ID");
    }
  }, [OnboardedContractorListData]);

  useEffect(() => {
    if (sendBulkEmailVerificationData?.status === "SUCCESS") {
      toast("Verification email sent successfully.");
      setIsSuccess(false);
      dispatch(adminAction.getDropdownDataKeyValue(dropdownDataKeyValueParams));
      getOnboardedContractorLists(defaultData);
      dispatch(userAction.ClearSendEmailVerification());
      setIsSuccess(false);
    }
  }, [sendBulkEmailVerificationData]);

  const sendBulkEmailVarifation = (payload) => {
    if (InactiveClient()) return;

    const data = {
      ids: [payload?.row?.userId],
      type: 1,
    };
    dispatch(userAction.postSendBulkEmailVerification(data));
  };

  return (
    <>
      {showLoader && <Loader />}
      {isLoading && <Loader />}
      {sendBulkEmailVerificationDataIsLoading && <Loader />}
      {updateOnboardedContractorListDataStatus === API_STATUS.SUCCESS &&
        updateOnboardedContractorListData?.data &&
        isSuccess &&
        toast("Contractor Added Successfully")}
      {recreateUsersReducerstatus === API_STATUS.SUCCESS &&
        isSuccess &&
        toast("Welcome Email Send Successfully")}
      <div>
        <ToastContainer />
      </div>
      <ContractorConfigurationList
        getOnboardedContractorLists={getOnboardedContractorLists}
        OnboardedContractorListData={OnboardedContractorListData}
        loading={OnboardedContractorListData.isLoading}
        updateOnboardedContractorList={updateOnboardedContractorList}
        recreateUsersList={recreateUsersList}
        onboardContractorStatus={onboardContractorStatus}
        sendBulkEmailVarifation={sendBulkEmailVarifation}
        OnboardedContractorListDataList={OnboardedContractorListData}
        shouldRestoreState={shouldRestoreState}
        division={division}
      />
    </>
  );
}

export default ConrtactorConfigurationListContainer;
